// 무기 팔레트(tools/blender/hero/hero_weapons.py PALETTE와 같은 순서·값 — heroWeapons.test.ts가 매니페스트와 대조한다).
// 무기 GLB는 UV가 팔레트 칸 가운데를 가리킨다. 정점 색 재질(라이라 장비 gearMaterial·용병 툰)에서는 UV → 칸 → 색으로 바꿔 쓴다.
import * as THREE from 'three/webgpu';

export const WEAPON_PALETTE_GRID = 8;
/** [이름, 베이스 색, 발광 색 또는 null] */
export const WEAPON_PALETTE: ReadonlyArray<readonly [string, number, number | null]> = [
  ['wood_dark', 0x3d2618, null],
  ['wood', 0x5b3a24, null],
  ['wood_light', 0x8a5a36, null],
  ['leather', 0x4a2e1c, null],
  ['leather_red', 0x7a2a22, null],
  ['cloth_white', 0xf1ede4, null],
  ['cloth_navy', 0x26304f, null],
  ['rope', 0xb59a6a, null],
  ['iron', 0x5d636b, null],
  ['iron_dark', 0x3a3f46, null],
  ['steel', 0x8e98a4, null],
  ['steel_light', 0xc3ccd6, null],
  ['brass', 0xb0813a, null],
  ['gold', 0xe2b54a, null],
  ['gold_light', 0xf6dc8a, null],
  ['silver', 0xd9dde4, null],
  ['white_lacquer', 0xefe9dc, null],
  ['teal_wood', 0x2f5653, null],
  ['teal_wood_dark', 0x24403e, null],
  ['ivory', 0xe8dcc0, null],
  ['violet', 0xb07cff, 0x9a5cff],
  ['violet_dim', 0x6d4aa8, null],
  ['orange', 0xff8a3d, 0xff7a20],
  ['ice', 0x9fd8ff, 0x7cc8ff],
  ['rune_blue', 0x4a8cff, 0x3f7dff],
  ['rune_gold', 0xf2c94c, 0xffcc33],
  ['holy', 0xffe48a, 0xffd34a],
  ['teal_glow', 0x3fd0c0, 0x2fe0c8],
  ['navy_paint', 0x2b3a66, null],
  ['red_paint', 0x9a2b2b, null],
  ['feather', 0xe9f3f2, null],
  ['feather_teal', 0x5fbfb3, null],
];

/**
 * UV(glTF: v 아래로) → 팔레트 칸 → 정점 색. 발광 칸은 glow배(>1)로 둬서 정점 색이 1을 넘는 곳을 빛내는 재질(lyraLook gearMaterial)과 맞는다.
 * 새 BufferGeometry를 돌려준다(원본은 그대로).
 */
export function paletteVertexColors(src: THREE.BufferGeometry, glow = 1.8): THREE.BufferGeometry {
  const g = src.clone();
  const uv = g.getAttribute('uv');
  const n = g.getAttribute('position').count;
  const col = new Float32Array(n * 3);
  const c = new THREE.Color();
  const G = WEAPON_PALETTE_GRID;
  for (let i = 0; i < n; i++) {
    const u = uv ? uv.getX(i) : 0, v = uv ? uv.getY(i) : 0;
    const cx = Math.min(G - 1, Math.max(0, Math.floor(u * G))), cy = Math.min(G - 1, Math.max(0, Math.floor(v * G)));
    const e = WEAPON_PALETTE[cy * G + cx] ?? WEAPON_PALETTE[0];
    c.setHex(e[1]);
    const k = e[2] !== null ? glow : 1;
    col[i * 3] = c.r * k; col[i * 3 + 1] = c.g * k; col[i * 3 + 2] = c.b * k;
  }
  g.setAttribute('color', new THREE.BufferAttribute(col, 3));
  return g;
}
